module.exports = __webpack_public_path__ + "static/img/one-of-us-cover.4ebd4c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/one-of-us-cover.png
// module id = W/8o
// module chunks = 0